module.exports = __webpack_public_path__ + "static/dnafoil-logo-color-632b5dbed93b27452e3ca2701559b585.png";